import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';

export const labelWrapper = flex({
  align: 'center',
  justify: 'space-between',
  w: '100%',
  py: 16,
});

export const label = css({
  textStyle: 'Text/L/Strong',
  color: 'inverse.white',
});

export const actions = css({
  py: 8,
  px: 0,
});

export const row = flex({
  gap: 6,
});

export const col = css({
  flex: 1,
  w: '50%',
  maxW: 161,
  wordBreak: 'break-word',
  color: 'content.default.level-2',
});

export const price = css({
  mr: 4,
  color: 'inverse.white',
});

// FIXME: FormItem 컴포넌트 panda css로 리팩토링 후 important 제거
export const formItem = css({
  pos: 'relative',
  w: '100%',
  pt: '0px!',
  pb: '16px!',
});

export const info = css({
  py: 16,
});
